import React from 'react';
import Employee from './Employee';
import './index.scss';

const Index = () => {
	return <Employee />;
};

export default Index;
